import React from 'react'

interface Props {
  height?: number
}

const BottomNavigationPlaceholder: React.SFC<Props> = ({ height }) => (
  <div style={{ height: height || 56.34 }} />
)

export default BottomNavigationPlaceholder
